module.exports = __webpack_public_path__ + "static/media/EULA_Saarthi_Simulations_Inc.c0c5079b.pdf";